module.exports = __webpack_public_path__ + "img/megafon-disabled.c4c3d902.svg";